import CatalogItem from "@components/Actions/CatalogItems/Base";
import Icon from "@components/Atoms/Icon";
import { useRouter } from "@core/Api/useRouter";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import { catalogDeleteConfirm } from "@ext/catalog/actions/propsEditor/components/catalogDeleteConfirm";
import { useDeleteCatalog, useDeleteCloudCatalog } from "@ext/catalog/actions/propsEditor/components/useDeleteCatalog";
import t from "@ext/localization/locale/translate";
import { ConfirmMenuItem } from "@ui-kit/ConfirmPopover";
import type { ReactNode } from "react";

interface DeleteCatalogProps {
	children: ReactNode;
	fromDevice?: boolean;
}

export const DeleteCatalog = ({ children, fromDevice }: DeleteCatalogProps) => {
	const router = useRouter();
	const { name, sourceName } = useCatalogPropsStore(
		(state) => ({ name: state.data?.name, sourceName: state.data?.sourceName }),
		"shallow",
	);
	const deleteCatalog = usePlatform().isStatic
		? useDeleteCloudCatalog({})
		: useDeleteCatalog({ name, onDeleted: () => router.pushPath("/") });

	const kind = fromDevice ? "device" : sourceName ? "storage" : "local";
	const label = (
		<>
			<Icon code={fromDevice ? "monitor-x" : "trash"} />
			{fromDevice ? t("catalog.delete.device.name") : t("catalog.delete.name")}
		</>
	);

	return (
		<CatalogItem
			renderLabel={(Item) =>
				children ? (
					<Item>{label}</Item>
				) : (
					<ConfirmMenuItem
						confirm={catalogDeleteConfirm(kind)}
						onConfirm={deleteCatalog}
						type={fromDevice ? undefined : "danger"}
					>
						{label}
					</ConfirmMenuItem>
				)
			}
		>
			{children}
		</CatalogItem>
	);
};

export default DeleteCatalog;
